import React, { createRef, Fragment, PureComponent } from "react";

export default class Score extends PureComponent {
  state = {
    overlap: false
  };
  constructor(props) {
    super(props);
    this.final = createRef();
  }
  check = () => {
    const final =
      this.final &&
      this.final.current &&
      this.final.current.getBoundingClientRect();

    const overlap =
      final &&
      final.y <= (window.innerHeight || document.documentElement.clientHeight);

    if (overlap !== this.state.overlap) {
      this.setState({ overlap });
    }
  };
  componentDidMount() {
    this.componentDidUpdate();
  }
  componentDidUpdate(prevProps) {
    if (this.props.completed && (!prevProps || !prevProps.completed)) {
      window.addEventListener("resize", this.check);
      window.addEventListener("scroll", this.check);
      this.check();
    }
  }
  render() {
    const { completed, numCorrect, numSubmitted } = this.props;
    return (
      <Fragment>
        {completed && (
          <div ref={this.final} className="final-score-outer">
            <div className="final-score">
              <span className="prefix">Final score: </span>
              <em>{numCorrect}</em> out of <em>{numSubmitted}</em>
            </div>
          </div>
        )}
        <div
          style={this.state.overlap ? { visibility: "hidden" } : undefined}
          className="score"
        >
          <span className="prefix">Score: </span>
          {numCorrect} / {numSubmitted}
        </div>
      </Fragment>
    );
  }
}
